// src/constants/roles.js

/**
 * Define todos los roles de la aplicación como constantes.
 * Esto ayuda a evitar errores tipográficos y facilita el mantenimiento.
 */
export const ROLES = {
    // Roles principales
    SUPER_ADMIN: 'super_administrador',
    ADMIN: 'administrador',
  
    // Roles departamentales/funcionales
    ALMACEN: 'almacen',
    VENTAS: 'ventas',
    PRODUCCION: 'produccion',
    FINANZAS: 'finanzas',
    DISTRIBUIDOR: 'distribuidor', // Asumiendo que es para comercial/logística
    RECURSOS_HUMANOS: 'recursos_humanos',
  
    // Estado especial para usuarios nuevos o sin rol asignado
    PENDIENTE: 'pendiente_de_asignacion',
  };
  
  // Opcional: Puedes crear arrays predefinidos para combinaciones comunes si lo deseas
  export const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.ADMIN];
  export const ALL_DASHBOARD_ACCESS_ROLES = [
      ROLES.SUPER_ADMIN,
      ROLES.ADMIN,
      ROLES.ALMACEN,
      ROLES.VENTAS,
      ROLES.PRODUCCION,
      ROLES.FINANZAS,
      ROLES.DISTRIBUIDOR,
      ROLES.RECURSOS_HUMANOS,
  ];
  
  // ... puedes añadir más combinaciones según necesites